import { render, staticRenderFns } from "./SetTactics.vue?vue&type=template&id=98dc1322&scoped=true&"
import script from "./SetTactics.vue?vue&type=script&lang=js&"
export * from "./SetTactics.vue?vue&type=script&lang=js&"
import style0 from "./SetTactics.vue?vue&type=style&index=0&id=98dc1322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc1322",
  null
  
)

export default component.exports